var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"wl-check",class:{'wl-check--ischecked' : _vm.checked},attrs:{"id":_vm.id},on:{"click":function($event){return _vm.select()}}})}
var staticRenderFns = []

export { render, staticRenderFns }